import { useEffect, useState } from "react";

// Hand preference for the tablet side palette (non-sensitive) — localStorage is appropriate.
const HAND_KEY = "ccs-left-hand";
export const isLeftHand = () => localStorage.getItem(HAND_KEY) === "1";
export const setLeftHand = (v) => localStorage.setItem(HAND_KEY, v ? "1" : "0");

const isTouch = () => (window.matchMedia?.("(pointer: coarse)").matches || navigator.maxTouchPoints > 0);

// "phone" | "tablet-portrait" | "tablet-landscape" | "desktop"
export const detectLayout = () => {
  const w = window.innerWidth, h = window.innerHeight;
  if (w < 768) return "phone";
  if (!isTouch()) return "desktop";
  return w >= h ? "tablet-landscape" : "tablet-portrait";
};

export const useLayoutMode = () => {
  const [mode, setMode] = useState(detectLayout);
  useEffect(() => {
    const update = () => setMode(detectLayout());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => { window.removeEventListener("resize", update); window.removeEventListener("orientationchange", update); };
  }, []);
  return mode;
};
